// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-item[data-v-651d5643] {\n  margin-top: 8px;\n}\n.url-item[data-v-651d5643] {\n  margin-bottom: 12px;\n}", ""]);
// Exports
module.exports = exports;
